/**
 * The skip link (TMM-B7, A11Y): the first focusable element of every layout, hidden until it has
 * keyboard focus, jumping to `main#main` (which carries `tabIndex={-1}`). The app shell and the
 * blank-slate routes (sign-in errors, session endings, no access) all render it.
 */
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { resolveTokens } from '@/theme';

export function SkipLink() {
  const { t } = useTranslation();
  const theme = useTheme();
  const tokens = resolveTokens(theme);
  return (
    <Box
      component="a"
      href="#main"
      sx={{
        position: 'absolute',
        insetInlineStart: theme.spacing(1),
        top: theme.spacing(1),
        zIndex: theme.zIndex.tooltip,
        px: 2,
        py: 1,
        bgcolor: 'background.paper',
        color: tokens.link,
        borderRadius: 1,
        transform: 'translateY(-200%)',
        '&:focus': { transform: 'none' },
      }}
    >
      {t('shell.skipToContent')}
    </Box>
  );
}
